<script lang="ts">
	import { Router, Route } from "svelte-routing";
	import Redirect from "./components/Redirect.svelte";
	import Header from "./components/Header.svelte";
	import Footer from "./components/Footer.svelte";
	import Search from "./pages/Search.svelte";
	import Support from "./pages/Support.svelte";
	import About from "./pages/About.svelte";
	import Publication from "./pages/Publication.svelte";

	export let url = "";
</script>

<main class="flex flex-col h-screen md:h-full md:h-screen bg-white">
	<div class="flex flex-col md:grid wrapper max-h-screen">
		<Header />
		<div class="flex-grow z-10 overflow-y-scroll">
			<Router {url}>
				<Route path="/">
					<Redirect path="/search" />
				</Route>
				<Route path="search">
					<Search participant="" />
				</Route>
				<Route path="search/:id" let:params>
					<Search participant={params.id} />
				</Route>
				<Route path="support">
					<Support />
				</Route>
				<Route path="about">
					<About />
				</Route>
				<Route path="publication">
					<Publication />
				</Route>
			</Router>
		</div>
		<Footer />
	</div>
</main>

<style windi:preflights:global windi:safelist:global>
</style>
